import DialogModal from '@/components/DialogModal';
import { Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

type ConfirmThunk = () => (value: boolean) => void;

type Props = {
  isOpen: boolean;
  onCloseConfirmationModal: () => void;
  setResolveConfirmPromise: React.Dispatch<React.SetStateAction<ConfirmThunk | null>>;
};

const RecurringConfirmationModal = ({ isOpen, onCloseConfirmationModal, setResolveConfirmPromise }: Props) => {
  const { t } = useTranslation('ActionModal');
  return (
    <DialogModal
      isOpen={isOpen}
      title={t('labels.editRecurringConfirmTitle')}
      message={t('labels.editRecurringConfirmMessage')}
      onCancel={() => {
        setResolveConfirmPromise?.((prev) => {
          if (typeof prev === 'function') {
            const finish = prev();
            if (typeof finish === 'function') {
              finish(false);
            }
          }
          return null;
        });
        onCloseConfirmationModal();
      }}
      onConfirm={() => {
        setResolveConfirmPromise?.((prev) => {
          if (typeof prev === 'function') {
            const finish = prev();
            if (typeof finish === 'function') {
              finish(true);
            }
          }
          return null;
        });
        onCloseConfirmationModal();
      }}
      confirmVariant="primary"
      confirmText={t('buttons.updateAction')}
    >
      <Text marginTop={4} color="text-secondary" fontSize="lg" fontWeight={500} whiteSpace="pre-line">
        {t('labels.editRecurringConfirmCalendarHint')}
      </Text>
    </DialogModal>
  );
};

export default RecurringConfirmationModal;
